<div class="document-selection">
  <div class="document-selection__background" aria-hidden="true">
    <img
      class="document-selection__background-image"
      src="assets/img/bg-documents.png"
      alt=""
    />
    <img
      class="document-selection__binder"
      src="assets/img/bg-documents-binder.png"
      alt=""
    />
  </div>

  <div class="document-selection__content">
    <app-header />

    <div class="document-selection__main">
      <section class="document-selection__hero" aria-labelledby="document-selection-title">
        <h1 id="document-selection-title" class="document-selection__title">
          Veuillez sélectionner un document à consulter
        </h1>
      </section>

      @if (loading()) {
        <p class="document-selection__status" role="status">Chargement des documents…</p>
      } @else if (!hasDocuments()) {
        <p class="document-selection__status" role="status">
          Aucun document n'est disponible pour le moment.
        </p>
      } @else {
        <section
          class="document-selection__slider"
          aria-label="Liste des documents"
          aria-roledescription="carousel"
        >
          <div class="document-selection__slider-viewport" aria-live="polite">
            @for (page of documentPages(); track $index) {
              @if (currentPage() === $index + 1) {
                <div
                  class="document-selection__slide"
                  role="group"
                  [attr.aria-label]="'Page ' + ($index + 1)"
                >
                  <div
                    class="document-selection__slide-grid"
                    [class.document-selection__slide-grid--sparse]="isSparseSlide(page)"
                  >
                    @for (document of page; track document.id) {
                      <app-document-card
                        [title]="document.title"
                        (pressed)="onDocumentSelected(document.id)"
                      />
                    }
                  </div>
                </div>
              }
            }
          </div>
        </section>
      }
    </div>

    <app-footer>
      <div class="document-selection__footer">
        <app-footer-nav [showScrollButton]="false" backRoute="/" />
        @if (hasDocuments() && totalPages() > 1) {
          <app-document-pagination
            class="document-selection__pagination"
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            (pageChange)="onPageChange($event)"
          />
        }
      </div>
    </app-footer>
  </div>
</div>
